// extracted by mini-css-extract-plugin
export default {"sorryContainer":"SpinWheelResults_sorryContainer__tTs4H","infoContainer":"SpinWheelResults_infoContainer__2Ximf","winContainer":"SpinWheelResults_winContainer__4p9Lb"};